<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">{{title}}</h1>
        </section>

        <section id="body">
            <form [formGroup]="addOptionalForm" (ngSubmit)="saveChanges(addOptionalForm.value)">
                <mat-card>

                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">

                        <div fxLayout="column" fxFlex="100">

                            <mat-form-field appearance="outline">
                                <mat-label>Nombre</mat-label>
                                <input matInput formControlName="name" required>
                                <mat-error *ngIf="addOptionalForm.controls['name'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                                <mat-error *ngIf="addOptionalForm.controls['name'].hasError('cannotContainSpace')">
                                    El nombre no puede ser un espacio en blanco
                                </mat-error>
                                <mat-error *ngIf="addOptionalForm.controls['name'].hasError('pattern')">
                                    Formato incorrecto, debe comenzar debe comenzar con mayúscula y sin espacios, ej: Ensaladas,Postres...
                                </mat-error>
                                <mat-hint>Debe comenzar debe comenzar con mayúscula y sin espacios</mat-hint>
                            </mat-form-field>

                            <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">

                                <!-- <mat-form-field appearance="outline">
                                    <mat-label>Cantidad mínima</mat-label>
                                    <input matInput formControlName="minQuantity">
                                </mat-form-field> -->

                                <mat-form-field appearance="outline">
                                    <mat-label>Cantidad máxima</mat-label>
                                    <input matInput formControlName="maxQuantity" required>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <mat-divider></mat-divider>

                    <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="0.5rem">
                        <div fxLayout="column" fxFlex="50">
                            <h2 class="cardHeader">Artículos</h2>
                            <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
                                <mat-list dense>
                                    <mat-list-item *ngFor="let item of products">
                                        <mat-checkbox [(ngModel)]="item.checked" [ngModelOptions]="{standalone: true}">
                                            {{ item.dsName }}
                                        </mat-checkbox>
                                    </mat-list-item>
                                </mat-list>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-evenly start" fxFlex="50">
                            <div fxLayout="column" fxFlex="50">

                                <h2 class="cardHeader addons">Addons</h2>

                                <mat-list fxLayout="column" dense>
                                    <mat-list-item *ngFor="let addon of addons">
                                        <mat-checkbox [(ngModel)]="addon.checked" [ngModelOptions]="{standalone: true}">
                                            {{ addon.dsName }}
                                        </mat-checkbox>
                                    </mat-list-item>
                                </mat-list>
                            </div>
                        </div>
                    </div>
                </mat-card>

                <br>

                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-flat-button type="submit" [disabled]="!addOptionalForm.valid" class="save-changes">
                        GUARDAR CAMBIOS
                    </button>
                    <button routerLink="/optionals-management" mat-raised-button
                        class="cancel-changes">CANCELAR</button>
                </div>
            </form>
        </section>
    </div>
</div>